
export const ROWSPERPAGE = 10

export const META_DATA_MONITORING = {
    title: 'SM | Giám sát độ mặn',
    image: '/logo-240x240.png',
    logo_one: '/images/SHG.png',
    logo_two: '/images/IoTLab.png',
    icon: '/favicon.ico',
    description: 'Description',
    url: '',
    author: 'CTU',
    keyword: 'key, react'
}

